
const getters={
  title:(state)=>state.title,
  second_id:(state)=>state.second_id,
}
export default getters;


// WEBPACK FOOTER //
// ./src/store/getters.js